import { appConfig } from "../../appConfig";
import { getEnv } from "../env";
import { getQueryStringVariable } from "./getQueryStringVariable";

export function loadLanguage() {
	//let lang = window.cg_LCODE || appConfig.language || appConfig.LANGUAGE;
	let lang = getQueryStringVariable("language");	
	if (lang == null) {
		lang = window.cg_LCODE || appConfig.language || appConfig.LANGUAGE;		
	}
    if (lang == null) {
        lang = getEnv('REACT_APP_LANGUAGE');
    }
	return lang == null ? 'IT': lang.toUpperCase();
}
